<template>
  <div>
  <v-card scrollable>
        <v-card-title class="primary" pt0>
          <h6 class="white--text">Kilometraje Vendedor</h6>
           <v-btn
                  absolute
                  dark
                  small
                  fab
                  button
                  right
                  class="accent"
                  @click.native="dialog = true"
                >
             +
        </v-btn>
        </v-card-title>
        <v-card-text>
                      <v-container>
            <v-layout>
              <v-flex style="overflow-x: auto" xs12>
                <table class="table">
                  <thead>
                    <th class="pa-0 ma-0"></th>
                    <th class="pa-0 ma-0"></th>
                    <th>Fecha</th>
                    <th>Usuario</th>
                    <th>día</th>
                    <th>semana</th>
                    <th>Kilometraje Inicial</th>
                    <th>Kilometraje Final</th>
                  </thead>
                  <tbody class="ma-0 pa-0">
                    <tr v-for="kilometraje in kilometraje.results">
                      <td class="text-xs-left pa-0">
                        <v-btn icon class="red--text text--darken-2 btn--small" @click="eliminar(kilometraje) " pa-0 ma-0>
                          <v-icon>delete</v-icon>
                        </v-btn></td>
                      <td class="text-xs-left pa-0">
                        <v-btn icon class="blue--text text--darken-2 " @click="editar(kilometraje)">
                          <v-icon>edit</v-icon>
                        </v-btn></td>
                      <td class="text-xs-center text-xs-left pa-0">{{kilometraje.fecha | formatDate2}}</td>
                      <td class="text-xs-center text-xs-left pa-0">{{kilometraje.user_name}}</td>
                      <td class="text-xs-center text-xs-left pa-0">{{kilometraje.dia}}</td>
                      <td class="text-xs-center text-xs-left pa-0">{{kilometraje.semana}}</td>
                      <td class="text-xs-center text-xs-left pa-0 ma-0">{{kilometraje.kilometraje_inicial}}</td>
                      <td class="text-xs-center text-xs-left pa-0 ma-0">{{kilometraje.kilometraje_final}}</td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent="">
      <v-card>
        <v-card-title primary>
          <span class="headline"> Kilometraje </span>
        </v-card-title>
        <v-card-text>
          <v-text-field label="Kilometraje Inicial:" v-model="akilometraje.kilometraje_inicial"></v-text-field>
          <v-text-field label="Kilometraje Final:" v-model="akilometraje.kilometraje_final"></v-text-field>
          <v-text-field label="día:" v-model="akilometraje.dia"></v-text-field>
          <v-text-field label="Semana:" v-model="akilometraje.semana"></v-text-field>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="cerrar">Cerrar</v-btn>
          <v-btn class="blue--text darken-1" flat @click="editarkilometraje">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
 </div>
</template>

<script>
  export default{
    created () {
      this.$store.dispatch('getkilometrajevendedor')
    },
    data () {
      return {
        auto_name: '',
        fecha: ''
      }
    },
    methods: {
      eliminar: function (dato) {
        this.$store.dispatch('eliminarkilometrajevendedor', dato)
      },
      editarkilometraje: function () {
        let dato = this.$store.getters.akilometrajevendedor
        let data = dato
        this.$store.dispatch('crearkilometrajevendedor', data)
        this.$store.commit('actualizardialog', false)
      },
      editar (dato) {
        this.$store.commit('actualizardialog', true)
        this.$store.commit('actualizarakilometrajevendedor', dato)
      },
      cerrar: function () {
        this.$store.commit('actualizardialog', false)
      }
    },
    computed: {
      kilometraje () {
        return this.$store.getters.kilometrajevendedor
      },
      akilometraje () {
        return this.$store.getters.akilometrajevendedor
      },
      dialog: {
        get: function () {
          return this.$store.getters.dialogo
        },
        set: function (dato) {
          this.$store.commit('actualizardialog', dato)
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// KilometrajeVendedor.vue?830da02a